import React from 'react'
import { Shoe } from '../../../assets/images'
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles'

const StepathonUtilization = ({classes = '', label = '', color = '', title = '', icon = '', imgClasses = 'h-16 w-16', btnText = '', titleClasses='text-gray-800', labelClasses = 'text-base leading-4 font-semibold text-gray-900 mt-4',  handler = () => {}}) => {
  return (
    <div className={'text-center py-12 rounded-md h-full' + classes} style={{backgroundColor: color}}>
      <img className={`${imgClasses} inline-block`} src={icon || Shoe}/>
      <label className={`block ${labelClasses}`}>{label}</label>
       {title && <p className={`${titleClasses} text-base leading-5 mt-3 mb-0`}>{title}</p>}
      {btnText && 
        <button className={joinButtonClasses(dsButtonPrimary, 'mt-3 h-11 px-6')} onClick={handler}>
          {btnText}
        </button>
      }
    </div>
  )
}

export default StepathonUtilization
